(function () {
  'use strict';

  angular.module('sempraWebapp').factory('LayoutViewModel', layoutViewModelFactory);

  /** @ngInject */
  function layoutViewModelFactory (applicationStore, $translate) {
    function LayoutViewModel () {
      this.hasError = false;
      this.isLoading = false;
      this.errorHeader = $translate.instant('SOMETHING_WENT_WRONG');
      this.errorName = $translate.instant('DEFAULT_ERROR_NAME');
      this.errorDescription  = $translate.instant('DEFAULT_ERROR_DESCRIPTION');
      init.call(this);
    }

    LayoutViewModel.prototype.destroy = function () {
      applicationStore.off(applicationStore.events.LOADER_CHANGE, this._showHideLoader);
    };

    return LayoutViewModel;

    function init () {
      // var that = this;
    }
  }
})();
